module.exports = __webpack_public_path__ + "static/media/horse1.fe85f962.jpg";